<template>
  <div class="contentModal">
    <div class="cardProcessRrim">
      <div class="title">
        <h3>Informações Gerais</h3>
      </div>
      <InformacaoGerais
        :configInputs="configInputs"
        @OBJ_Infor_Geral="getObjInforGeral"
        @mapMoldSap="getCavityMolde"

      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Produtos</h3>
      </div>
      <Produtos
        :configInputs="configInputs"
        @sendListaDeProdutos="getListPro"
      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Molde Fechado</h3>
      </div>
      
      <MoldeFechado
        :configInputs="configInputs"
        @dataMoldeFechado="getdataMoldeFechado"
      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Check-List da Engenharia e Ferramentaria</h3>
      </div>
      <ChecklistSlot
      :configInputs="configInputs"
      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Molde Aberto</h3>
      </div>
      <MoldeAberto
        :Cavity="Cavity"
        :configInputs="configInputs"
        @dataMoldeAberto="getDataMoldeAberto"
        @setCavity="getCavityTOTAL"
      />
    </div>
  </div>
</template>

<script>
import ChecklistSlot from "../../../../Tables/ChecklistSlot.vue";
import InformacaoGerais from "./Modules/Informacao-Gerais.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import Produtos from "./Modules/Produtos.vue";

export default {
  components: { InformacaoGerais, MoldeAberto, MoldeFechado, Produtos, ChecklistSlot },
  data() {
    return {
      t: "",
      Cavity: 0,
    };
  },
  props: {
    configInputs: Number,
  },
  methods: {
    getObjInforGeral(Obj) {
      this.$emit("setObjOfInforGeral", Obj);
    },

    getListPro(List) {
      this.$emit("setListPro", List);
    },

    getdataMoldeFechado(Obj) {
      this.$emit("setObjMoldeFechado", Obj);
    },

    getDataMoldeAberto(Obj) {
      this.$emit("setObjMoldeAberto", Obj);
    },
    getCavityMolde(cavity){
      this.Cavity = cavity

    },
    getCavityTOTAL(cavity){
      this.$emit("setCavity", cavity);
    }
  },
};
</script>

<style scoped>
::placeholder {
    font-weight: 400;
    color: red!important;
}
.contentModal {
  height: 100%;
  transition: 0.5s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.contentModal .cardProcessRrim {
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
  padding: 0rem 2rem;
  width: 100%;
  position: relative;
  padding: 0rem 2.5rem 0.8rem 2.5rem;
  background-color: var(--white);
  border-radius: 0.4rem;
}

.contentModal .cardProcessRrim .title {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--font_color);
  padding-bottom: 0.8rem;
}

h3 {
  font-size: 1rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}


@media (max-width: 400px) {
  .contentModal .cardProcessRrim {
  padding: 0rem 2rem;
  width: 100%;
  position: relative;
  padding: 0rem 1rem 0.8rem 1rem;
  background-color: var(--white);
  border-radius: 0.4rem;
}
}

</style>
